import { NgModule } from '@angular/core';
import { FormControlPipe } from '../pipes/form-control.pipe';

const pipeModules = [FormControlPipe];

@NgModule({
  declarations: [...pipeModules],
  exports: [...pipeModules],
})
export class PipeModule {}
